<script lang="ts">
    import type {Writable} from "svelte/store";
    import {getContext, createEventDispatcher} from "svelte";
    import {Input, Label, Select, Tooltip} from "flowbite-svelte";
    import {IconSolid, LinkOutline} from "flowbite-svelte-icons";
    import type {InputType} from "flowbite-svelte/dist/types";

    export let icon: any | null = null;
    export let title: string | null = null;
    export let value: string | number = "";
    export let super_edit: Writable<boolean> = getContext('super_edit');
    export let name: string = "";

    export let type:InputType="text"

    export let displayClass = "";

    export let link:string|null = null;

    export let items: any[] = []

    export let readonly = false

    export let step = 1

    export let pattern = ".*"

    export let placeholder = ''

    let className = "";

    export {className as class};

    const components = {
        'text': Input,
        'number': Input,
        'select': Select
    }
    const dispatcher = createEventDispatcher()

    function dispatch(event) {
        dispatcher('change', event)
    }

    $: editing = $super_edit && !readonly ? '' : 'border-transparent bg-transparent disabled:opacity-100 disabled:cursor-default hide-select';

    let selectFix = type === 'select' ? 'py-1 ' : ''

</script>

<div>
    {#if title}
    <Label class="{(''+value).length < 1 ? 'text-red-500' : 'text-gray-500'} text-lg leading-6" for="{name}">{title} </Label>
    {/if}
    {#if !$$slots.default}
        <div class="relative -left-1 flex gap-2 items-center">
            {#if icon && typeof icon === 'string'}
                <svelte:component this={components[type]} {placeholder} {step} {pattern} on:change={dispatch}  class="w-full text-neutral-600 text-[16px] py-1 pl-7 {selectFix} {className} {editing}" {items} {type} {name} disabled={!$super_edit || readonly} bind:value>
                    <iconify-icon slot="left" icon={icon} class="w-4 text-primary-400"/>
                </svelte:component>
            {:else if icon}
                <svelte:component this={components[type] ?? Input} {placeholder} {step} {pattern} on:change={dispatch} class="w-full text-neutral-600 text-[16px] py-1 pl-7 {selectFix} {className} {editing}" {items} {type} {name} disabled={!$super_edit || readonly} bind:value>
                    <IconSolid slot="left" {icon} class="w-4 text-primary-400"/>
                </svelte:component>
            {:else}
                <svelte:component this={components[type] ?? Input} {placeholder} {step} {pattern} on:change={dispatch} class="w-full text-neutral-600 py-1 pl-1 {selectFix} {className} {editing}" {items} {type} {name} disabled={!$super_edit || readonly} bind:value/>
            {/if}
            {#if link && !$$slots.right}
                <a href={link} target="_blank" rel="noreferrer noopener"><LinkOutline class="w-4"/> </a>
                <Tooltip>{link}</Tooltip>
            {:else}
                <slot name="right"></slot>
            {/if}
        </div>
    {:else}
        <div class="flex gap-3">
            <slot name="left"></slot>
            {#if $super_edit && !readonly}
                <slot {value} x_name="{name}"/>
            {:else if link}
                <a class="pt-2 text-sm {displayClass}" href={link}>{value}</a>
            {:else}
                <span class="pt-2 text-sm {displayClass}">{items.length ? items.find(i => i.value === value)?.name : value || '-'}</span>
            {/if}
        </div>

    {/if}
</div>

